import React from "react";

const Pay = () => {
  return (
    <div>
      <h1 className="text-center py-5 common-title text-secondary">Payment</h1>
      <p className="text-center  text-secondary fs-3">
        Sorry! Payment process will be soon available.
      </p>
    </div>
  );
};

export default Pay;
